import { render, staticRenderFns } from "./KompasLegenda.vue?vue&type=template&id=c26ffcdc&"
import script from "./KompasLegenda.vue?vue&type=script&lang=js&"
export * from "./KompasLegenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports